import { ErrorPage } from '../index';
import { initServerTranslation } from '@bts-web/utils-lokalise';

const ErrorGenericPage = async () => {
  const { t } = await initServerTranslation();

  return (
    <ErrorPage
      title={t('general_error_headline')}
      description={t('general_error_text')}
    />
  );
};

export { ErrorGenericPage };
